var map = {
	"./circle_black.svg": 1015,
	"./circle_blue.svg": 1016,
	"./ellipse_black.svg": 1017,
	"./france.svg": 305,
	"./highlighted_yellow.svg": 1018,
	"./icons/Cart.svg": 1019,
	"./icons/Cart_add.svg": 1020,
	"./icons/Cart_delete.svg": 1021,
	"./icons/Cart_remove.svg": 1022,
	"./icons/_info.svg": 1023,
	"./icons/add_prod.svg": 1024,
	"./icons/add_prodOLD.svg": 1025,
	"./icons/ask.svg": 1026,
	"./icons/carousel.svg": 1027,
	"./icons/facebook.svg": 117,
	"./icons/hatchef.svg": 367,
	"./icons/icone/_info.svg": 1028,
	"./icons/icone/book-open-solid.svg": 360,
	"./icons/icone/bookmark-solid.svg": 366,
	"./icons/icone/columns-solid.svg": 361,
	"./icons/icone/file-pdf-solid.svg": 363,
	"./icons/icone/hatchef.svg": 1029,
	"./icons/icone/info.svg": 1030,
	"./icons/icone/list-solid.svg": 365,
	"./icons/icone/magnifying-glass-solid.svg": 362,
	"./icons/icone/play.svg": 1031,
	"./icons/icone/plus.svg": 1032,
	"./icons/icone/share-square-solid.svg": 364,
	"./icons/icone/specs.svg": 1033,
	"./icons/icone/world.svg": 1034,
	"./icons/index-icon-bookmark.svg": 1035,
	"./icons/index-icon.svg": 1036,
	"./icons/info.svg": 373,
	"./icons/markers-SVG/ask.svg": 1037,
	"./icons/markers-SVG/info.svg": 1038,
	"./icons/markers-SVG/list.svg": 1039,
	"./icons/markers-SVG/recipe.svg": 1040,
	"./icons/markers-SVG/web.svg": 1041,
	"./icons/play.svg": 370,
	"./icons/play_ip.svg": 1042,
	"./icons/plus.svg": 368,
	"./icons/promo.svg": 372,
	"./icons/promo2.svg": 1043,
	"./icons/promo3.svg": 1044,
	"./icons/promo_10.svg": 1045,
	"./icons/promo_classic.svg": 1046,
	"./icons/remove_prod.svg": 1047,
	"./icons/remove_prodOLD.svg": 1048,
	"./icons/shop_list.svg": 1049,
	"./icons/specs.svg": 371,
	"./icons/whatsapp.svg": 118,
	"./icons/world.svg": 369,
	"./logo_interattivo_free.svg": 1050,
	"./logo_volantinointerattivo_free.svg": 374
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1014;